import { usePdfAsImage } from 'features/knowledgeDocumentViewer/components/viewer/image/hooks/usePdfAsImage'
import { FileText } from 'lucide-react'
import styled from 'styled-components'

import { useWorkOrderPdf } from './useWorkOrderPdf'

const Frame = styled.div<{ $size: number }>`
  width: ${({ $size }) => ($size * 612) / 792}rem;
  height: ${({ $size }) => $size}rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--muted);
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export function WorkOrderThumbnail({
  documentId,
  alt,
  pageNumber = 1,
  maxDimensionRem = 6,
}: {
  documentId: string
  alt: string
  pageNumber?: number
  maxDimensionRem?: number
}) {
  const { pdfUrl, pdf, isLoading } = useWorkOrderPdf(documentId)
  const { imageUrl } = usePdfAsImage(
    pdfUrl,
    pageNumber,
    1,
    pdf?.pageCount ?? 1,
    true,
    { preloadAdjacentPages: false }
  )
  return (
    <Frame $size={maxDimensionRem} aria-busy={isLoading}>
      {imageUrl ? (
        <img src={imageUrl} alt={alt} />
      ) : (
        <FileText aria-label={alt} />
      )}
    </Frame>
  )
}
